import { SekoEnvironment } from "@redotech/redo-integrations-definitions-common/integration/seko/seko-environment";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const sekoSettings = defineIntegrationSettings({
  fields: {
    username: z.string().trim().min(1, "Username is required"),
    environment: createEnum(SekoEnvironment),
  },
  secrets: {
    apiKey: z.string().trim().min(1, "API key is required"),
    password: z.string().trim().min(1, "Password is required"),
  },
  connectOnly: {},
  computed: { enabled: z.boolean() },
});
